import React from 'react'
import { CloseIconBlue } from 'assests/GmsIcons'
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon'

type TCategoryItemProps = {
    item: TCategory
    isSelected: boolean
    isOverridden?: boolean
    handleClick: (categoryId: string) => void
    disabledClick: boolean
}

const CategoryItem = ({ item, isSelected, isOverridden, disabledClick, handleClick }: TCategoryItemProps) => {
    return (
        <div
            key={item.id}
            className={`${disabledClick ? "tw-pointer-events-none" : "tw-cursor-pointer"}tw-flex tw-items-center tw-space-x-2 tw-m-1`}
            onClick={() => disabledClick ? null : handleClick(item.id)}
        >
            {isOverridden ? (
                <div className="tw-px-3 tw-py-1 tw-bg-gray-100 tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-zinc-300 tw-inline-flex tw-justify-start tw-items-start tw-gap-1">
                    <div className="tw-justify-start tw-text-slate-500 tw-text-xs tw-pointer-events-none">{item.name}</div>
                    <div className=" tw-relative tw-overflow-hidden">
                        <OverlayIcon
                            message="Category overriden in another submodel"
                            placement="bottom"
                        />
                    </div>
                </div>
            ) : <div className={`${isSelected ? "tw-pl-3 tw-bg-blue-800/10" : "tw-px-3 tw-bg-indigo-50"} ${disabledClick ? "tw-pointer-events-none" : ""}tw-cursor-pointer tw-py-1 tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-blue-800 tw-inline-flex tw-justify-start tw-items-start`}>
                <div className={`${disabledClick ? "tw-pointer-events-none" : ""} tw-cursor-pointer tw-justify-start tw-text-blue-800 tw-text-xs`}>{item.name}</div>
                {isSelected && <div className='tw-pl-1 tw-pr-2'><CloseIconBlue /></div>}
            </div>}
        </div>
    )
}

export default CategoryItem